import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import {
  AttachFetchType,
  AttachListFetch,
  AttachObjectType,
  AttachDownloadFetch,
} from './Attachment.type';

let listTypesRequest: any = null;
let listRequest: any = null;
let downloadRequest: any = null;
let updatesRequest: any = null;

const attachmentService = {
  getTypes: () => {
    listTypesRequest && listTypesRequest.cancel();
    listTypesRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`attachments/types`), {
      cancelToken: listTypesRequest.token,
    });
  },
  getList: (params: AttachListFetch) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`attachments`), {
      params,
      cancelToken: listRequest.token,
    });
  },
  getAttachmentDownload: (params: AttachDownloadFetch) => {
    downloadRequest && downloadRequest.cancel();
    downloadRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`attachments/download/${params.id}`), {
      cancelToken: downloadRequest.token,
      responseType: 'blob',
    });
  },
  sync: (object: AttachObjectType, attachments: AttachFetchType[]) => {
    updatesRequest && updatesRequest.cancel();
    updatesRequest = axios.CancelToken.source();
    const formData = new FormData();
    formData.append('objectType', object.type);
    formData.append('objectId', `${object.id}`);
    for (let i = 0; i < attachments.length; i++) {
      for (const key of Object.keys(attachments[i])) {
        // @ts-ignore
        const value = attachments[i][key];
        if (typeof value !== 'undefined') {
          if (key !== 'file') {
            formData.append(`attachments[${i}][${key}]`, value);
          } else {
            formData.append(
              `files[${attachments[i]['tmpUUID'] || attachments[i]['uuid']}]`,
              value,
              value.name,
            );
          }
        }
      }
    }
    return axios.put(getEndpointBase(`attachments/sync`), formData, {
      cancelToken: updatesRequest.token,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default attachmentService;
